"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotationService = void 0;
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const base_1 = require("../base");
const Interfaces_1 = require("../Interfaces");
var QuotationService;
(function (QuotationService) {
    function getKlineDataPromise(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { exchange = Interfaces_1.EXCHANGE_PIONEXV2, base, quote, interval } = params;
            const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().klineHost}/query_unite_candle_data`;
            const maxTimeRange = (0, base_1.getMaxTimeRange)(interval);
            const klineData = {
                hasMore: true,
                exchange,
                base,
                quote,
                interval,
                data: [],
            };
            while (klineData.hasMore && (klineData.data.length === 0 || params.start < klineData.data[0].time)) {
                let end = params.end;
                if (klineData.data.length > 0) {
                    end = klineData.data[0].time;
                }
                end = (0, base_1.toKlineTime)(end, interval);
                let start = end - maxTimeRange;
                if (start < params.start) {
                    start = params.start;
                }
                start = (0, base_1.toKlineTime)(start, interval);
                // 请求K线数据，出错时重试1次
                const data = yield (0, rxjs_1.firstValueFrom)((0, trade_utils_lib_1.requestWithRetry)(() => trade_utils_lib_1.Network.get({
                    url,
                    data: {
                        market: exchange,
                        base,
                        quote,
                        interval: interval.rest,
                        start: new trade_utils_lib_1.SafeDecimal(start).div(1000).toDP(0).toNumber(),
                        end: new trade_utils_lib_1.SafeDecimal(end).div(1000).toDP(0).toNumber(),
                    },
                    needProcessResp: false,
                }), {
                    maxRetryCount: 1,
                }));
                if (!data.history_price) {
                    data.history_price = [];
                }
                data.history_price = data.history_price.map((item) => {
                    return Object.assign({ time: item.date * 1000 }, item);
                });
                const newItems = data.history_price.filter((item) => {
                    return klineData.data.length === 0 || item.time < klineData.data[0].time;
                });
                klineData.data = [...newItems, ...klineData.data];
                klineData.hasMore = data.pre_has_more;
                if (newItems.length === 0) {
                    //没有数据就结束， 防止死循环
                    break;
                }
            }
            return klineData;
        });
    }
    function getKlineData(params) {
        return (0, rxjs_1.from)(getKlineDataPromise(params));
    }
    QuotationService.getKlineData = getKlineData;
})(QuotationService = exports.QuotationService || (exports.QuotationService = {}));
